@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.container {
  border-bottom: 1px solid @shipstation-balance-border-color;
  background-color: @shipstation-balance-background-color;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  width: 160px;
  height: 60px;
  padding: 12px;
  &.fullSize {
    border: 1px solid var(--grey-300);
    border-radius: 8px;
    flex-direction: row;
    width: 100%;
    padding: 8px 16px;

    &.sufficient {
      background-color: var(--green-200);
    }

    &.insufficient {
      background-color: var(--red-200);
    }
  }
}

.text {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: var(--grey-800);

  &.fullSize {
    flex-direction: column;
    font-size: 16px;
    color: var(--grey-900);
    line-height: 24px;
  }
}

.subtext {
  font-size: 12px;
  line-height: 18px;
}

.balance {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  &.fullSize {
    flex-direction: column;
    align-items: flex-end;
  }

  .amount {
    display: flex;
    font-size: 14px;
    line-height: 18px;
    color: var(--grey-900);

    &.fullSize {
      font-size: 20px;

      &.insufficient {
        color: var(--red-700);
      }
    }

    .error-icon {
      margin-right: 8px;

      &:hover {
        cursor: pointer;
      }

      > svg {
        width: 16px;
        height: 16px;
        fill: var(--red-600);
      }
    }
  }

  .link {
    font-size: 12px;
  }
}

.loading {
  height: 15px;
  width: 15px;

  &.fullSize {
    height: 30px;
    width: 30px;
  }
}

.story-wrapper {
  padding: 20px;
  width: 500px;
}

.menu-toggle {
  height: 32px;
  width: 32px;
  border-radius: 6px;
  color: var(--default--text-color--9);

  &:hover,
  &:focus {
    background-color: var(--primary--hover--background-color--1);
    color: var(--primary--hover--text-color--2);
  }

  &:active {
    background-color: var(--default--background-color--1);
    color: var(--default--text-color--12);
  }
}

.open-menu-toggle {
  background-color: var(--default--background-color--1);
  color: var(--default--text-color--12);
}

.menu-toggle-contents {
  display: flex;
  align-items: center;
  justify-content: center;

  & > svg {
    width: 16px;
  }
}

.wallet-tooltip {
  width: 250px;
}
